import React, { useState } from "react";
import {
  Modal,
  Button,
  Input,
  Tabs,
  Row,
  Col,
  Typography,
  Flex,
  Divider
} from "antd";
import {
  QuestionCircleOutlined,
  SearchOutlined,
  CloseOutlined
} from "@ant-design/icons";

const { Title, Text } = Typography;

const shortcuts = {
  navigation: [
    { name: "Sales Order", key: "Ctrl + F8" },
    { name: "Delivery Note", key: "Alt + F8" },
    { name: "Sales Invoice", key: "F8" },
    { name: "Sales Return", key: "Alt + F6" },
    { name: "Purchase Order", key: "Ctrl + F9" },
    { name: "Receipt Note", key: "Alt + F9" },
  ],
  common: [
    { name: "Shortcut Modal", key: "Shift + X" },
    { name: "Close Modals", key: "Esc" },
    { name: "Save Form", key: "Ctrl + S" },
    { name: "Create New", key: "Alt + N" },
  ]
};

const KeyBoardShortCut = () => {
  const [open, setOpen] = useState(false);
  const [search, setSearch] = useState("");

  const filterShortcuts = (items) =>
    items.filter((item) =>
      item.name.toLowerCase().includes(search.toLowerCase())
    );

  const totalShortcuts =
    shortcuts.navigation.length + shortcuts.common.length;

  return (
    <>
      <Button
        type="text"
        icon={<QuestionCircleOutlined style={{ fontSize: 20 }} />}
        onClick={() => setOpen(true)}
      />

      <Modal
        open={open}
        footer={null}
        width={900}
        onCancel={() => setOpen(false)}
        closeIcon={<CloseOutlined />}
        styles={{
          header: { background: "#647977", color: "#fff" }
        }}
        title={
          <div>
            <Title level={4} style={{ color: "#fff", marginBottom: 0 }}>
              Keyboard Shortcuts
            </Title>
            <Text style={{ color: "#d9f2ef" }}>
              Master your workflow with shortcuts
            </Text>
          </div>
        }
      >
        {/* Search */}
        <Input
          placeholder="Search shortcuts... (e.g., 'save', 'invoice', 'F8')"
          prefix={<SearchOutlined />}
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          style={{ marginBottom: 20 }}
        />

        <Tabs
          defaultActiveKey="all"
          items={[
            {
              key: "all",
              label: "All Shortcuts",
              children: (
                <Row gutter={40}>
                  <Col span={12}>
                    <Title level={5}>Navigation Shortcuts</Title>
                    <Divider style={{ marginTop: 4 }} />
                    {filterShortcuts(shortcuts.navigation).map((item) => (
                      <Flex
                        key={item.name}
                        justify="space-between"
                        style={{ marginBottom: 12 }}
                      >
                        <Text>{item.name}</Text>
                        <kbd>{item.key}</kbd>
                      </Flex>
                    ))}
                  </Col>

                  <Col span={12}>
                    <Title level={5}>Common Shortcuts</Title>
                    <Divider style={{ marginTop: 4 }} />
                    {filterShortcuts(shortcuts.common).map((item) => (
                      <Flex
                        key={item.name}
                        justify="space-between"
                        style={{ marginBottom: 12 }}
                      >
                        <Text>{item.name}</Text>
                        <kbd>{item.key}</kbd>
                      </Flex>
                    ))}
                  </Col>
                </Row>
              )
            },
            {
              key: "navigation",
              label: "Navigation",
              children: filterShortcuts(shortcuts.navigation).map((item) => (
                <Flex
                  key={item.name}
                  justify="space-between"
                  style={{ marginBottom: 12 }}
                >
                  <Text>{item.name}</Text>
                  <kbd>{item.key}</kbd>
                </Flex>
              ))
            },
            {
              key: "common",
              label: "Common Actions",
              children: filterShortcuts(shortcuts.common).map((item) => (
                <Flex
                  key={item.name}
                  justify="space-between"
                  style={{ marginBottom: 12 }}
                >
                  <Text>{item.name}</Text>
                  <kbd>{item.key}</kbd>
                </Flex>
              ))
            }
          ]}
        />

        {/* Footer */}
        <Divider />
        <Flex justify="space-between">
          <Text type="secondary">
            {totalShortcuts} shortcuts available
          </Text>
          <Button size="small" onClick={() => setOpen(false)}>
            Close
          </Button>
        </Flex>
      </Modal>
    </>
  );
};

export default KeyBoardShortCut;